<div class="p-5">
<h1 mat-dialog-title class="text-title text-xl font-semibold text-gray-800 mb-4">Video del Lote {{ data?.lotCode }}</h1>
<div mat-dialog-content class="p-0">
  <div class="relative w-full video-container">
    <iframe
      title="Video del Lote"
      class="absolute top-0 left-0 w-full h-full rounded-lg shadow-lg"
      [src]="videoUrl()"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      frameborder="0"
    ></iframe>
  </div>
</div>
</div>
